// jscs:disable
// jshint ignore: start

(function ($, njm) {
    'use strict';

    njm.views.njmsharesSlider = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            $('#autoPager').SalpySlider({
                name: '#autoPager', //Name of the div, div must include SalpySlider class
                type: 'panel', //panel or straight
                align: 'left', //left, center - starting position/active slide position for straight panel
                repeat: false, //true, false - when using straight, makes clones of divs to make endless scroll
                shown: 1, //How many shown at a time for the straight slider
                minwidth: 700, //min screen width for straight slider
                original_slide: 1, //starting slide
                pager: true, //true, false
                arrows: false, //true, false
                speed: 1000, //ms
                touch: true, //true, false
                auto: true, //true, false
                timer: 10000, //ms
                arrowLeft: '../assets/images/microsites/42.png', //url of left arrow
                arrowRight: '../assets/images/microsites/43.png' //url of right arrow
            });
        }
    });
})(jQuery, njm);
